import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import { getApi, patchApi, postFileApi } from "lib";
import {
  CREATE_SHOP_ORDER,
  PRODUCT_DETAILS,
  SEARCH_PRODUCTS,
  SHOP_DETAILS,
} from "services";

import { API_ERROR } from "utils/constant";

export const getShopDetails = createAsyncThunk(
  "Shop/getShopDetails",
  async (payload, thunkAPI) => {
    try {
      const pageNumber = payload?.page || 1;
      const response = await getApi(
        `${PRODUCT_DETAILS}?page=${pageNumber}&items_per_page=10&status=Published`);
      if (response?.data?.success) {
        return response?.data?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getProductDetails = createAsyncThunk(
  "Shop/getProductDetails",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(
        `${PRODUCT_DETAILS}?healonuser=true&product_id=${payload || ""}`
      );
      if (response?.data?.success) {
        return (
          response?.data?.data?.length && response?.data?.data[0]?.products[0]
        );
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postShopOrder = createAsyncThunk(
  "Shop/postShopOrder",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await postFileApi(CREATE_SHOP_ORDER, body);
      if (response?.data?.success) {
        next(response?.data?.data);
        return response?.data?.data?.id;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const patchShopOrder = createAsyncThunk(
  "Shop/patchShopOrder",
  async ({ body, next }, thunkAPI) => {
    try {
      const response = await patchApi(CREATE_SHOP_ORDER, body);
      if (response?.data?.success) {
        next();
        message.success(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getActiveShopOrders = createAsyncThunk(
  "orders/getActiveShopOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        CREATE_SHOP_ORDER +
          `?user_role=healon&sort_by=scheduled&page=${
            payload?.page || 1
          }&items_per_page=10`
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getCompletedShopOrders = createAsyncThunk(
  "orders/getCompletedShopOrders",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(
        CREATE_SHOP_ORDER +
          `?user_role=healon&sort_by=completed&page=${
            payload?.page || 1
          }&items_per_page=10`
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getShopOrderById = createAsyncThunk(
  "orders/getShopOrderById",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(CREATE_SHOP_ORDER + "?order_id=" + payload);
      if (response?.data?.success) {
        return response?.data?.data
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
export const getCategoryList = createAsyncThunk(
  "orders/getCategoryList",
  async (payload = "", thunkAPI) => {
    try {
      const response = await getApi(``);
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getSearchedProducts = createAsyncThunk(
  "Shop/getSearchedProducts",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(
        `${SEARCH_PRODUCTS}${payload?.name}&items_per_page=10&page=${payload?.page}`
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
